import { MotionViewport } from 'src/components/animate';
import Carousel, { CarouselArrows, useCarousel } from 'src/components/carousel';
import Iconify from 'src/components/iconify';
import { useSettingsContext } from 'src/components/settings';
import { useResponsive } from 'src/hooks/use-responsive';
import { useLocales } from 'src/locales';

const {
  Container,
  Stack,
  Grid,
  Typography,
  Avatar,
  Box,
  Card,
  useTheme,
  IconButton,
  alpha,
} = require('@mui/material');

function HomeTeam() {
  const { t } = useLocales();
  const theme = useTheme();
  const settings = useSettingsContext();
  const isDarkMode = settings.themeMode === 'dark';

  const mdUp = useResponsive('up', 'md');
  const smUp = useResponsive('up', 'sm');

  const DATA = [
    {
      imgUrl: `./assets/images/home/core-team/CORE_TEAM_CEO_${settings.themeMode.toUpperCase()}.png`,
      name: 'Hiroshi Hayashi',
      position: 'CEO',
      bio: 'walkup_lang_207',
      // socials: [{ link: 'https://twitter.com/LimjeongM', icon: 'mdi:twitter' }],
    },
    {
      imgUrl: `./assets/images/home/core-team/CORE_TEAM_CMO_${settings.themeMode.toUpperCase()}.png`,
      name: 'Jasmine Lim',
      position: 'CMO',
      bio: `walkup_lang_206`,
      // socials: [
      //   { link: 'https://www.linkedin.com/in/juyong-park-84b127b1/', icon: 'mdi:linkedin' },
      // ],
    },
    {
      imgUrl: `./assets/images/home/core-team/CORE_TEAM_CTO_${settings.themeMode.toUpperCase()}.png`,
      name: 'Ryota Anderson',
      position: 'CTO',
      bio: `walkup_lang_205`,
      // socials: [
      //   { link: 'https://www.linkedin.com/in/juyong-park-84b127b1/', icon: 'mdi:linkedin' },
      // ],
    },
  ];

  const carousel = useCarousel({
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: '0px',
    slidesToShow: 5,
    // auto play
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    // responsive
    responsive: [
      {
        // Down 900
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        // Down 650
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  const renderCarousel = (
    <Box sx={{ position: 'relative' }}>
      <CarouselArrows
        filled
        onPrev={carousel.onPrev}
        onNext={carousel.onNext}
        leftButtonProps={{
          sx: {
            display: smUp ? 'none' : '',
            p: 0.5,
            mt: -1.5,
            left: -8,
            '& svg': { width: 16, height: 16 },
          },
        }}
        rightButtonProps={{
          sx: {
            display: smUp ? 'none' : '',
            p: 0.5,
            mt: -1.5,
            right: -8,
            '& svg': { width: 16, height: 16 },
          },
        }}
      >
        <Box
          component={Carousel}
          ref={carousel.carouselRef}
          {...carousel.carouselSettings}
          sx={{
            width: 1,
            mx: 'auto',
          }}
        >
          {DATA.map((item, index) => (
            <Box key={index} sx={{ py: 5 }}>
              <Stack
                sx={{
                  bgcolor: 'background.default',
                  p: 3,
                  width: '90%',
                  margin: '0 auto',
                }}
              >
                <Stack alignItems="center">
                  <Avatar
                    src={item.imgUrl}
                    sx={{
                      width: 200,
                      height: 200,
                      border: `4px solid ${theme.palette.primary.main}`,
                    }}
                  />

                  <Typography variant="subtitle1" color={isDarkMode ? 'white' : 'default'}>
                    {item.name}
                  </Typography>
                  <Typography variant="subtitle1" color={isDarkMode ? 'white' : 'default'}>
                    {item.position}
                  </Typography>
                  <Typography
                    variant="caption"
                    color={isDarkMode ? 'white' : 'default'}
                    textAlign="center"
                  >
                    {t(item.bio)}
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          ))}
        </Box>
      </CarouselArrows>
    </Box>
  );

  return (
    <Container component={MotionViewport}>
      <Stack
        sx={{
          mb: { xs: 5, md: 10 },
        }}
        spacing={3}
      >
        <Typography variant="h2" textAlign="center" mb={5} color="primary">
          {t('walkup_lang_058')}
        </Typography>

        {!mdUp && renderCarousel}

        {mdUp && (
          <Grid container spacing={3} justifyContent="center">
            {DATA.map((item, index) => (
              <Grid key={index} item xs={12} md={3}>
                <Stack alignItems="center">
                  <Avatar
                    src={item.imgUrl}
                    sx={{
                      width: 200,
                      height: 200,
                      border: `4px solid ${theme.palette.primary.main}`,
                    }}
                  />

                  <Typography variant="subtitle1" color={isDarkMode ? 'white' : 'default'}>
                    {item.name}
                  </Typography>
                  <Typography variant="subtitle1" color={isDarkMode ? 'white' : 'default'}>
                    {item.position}
                  </Typography>

                  {item.socials && (
                    <Stack direction="row" alignItems="center" spacing={1} my={1}>
                      {item.socials.map((social) => (
                        <IconButton
                          sx={{
                            background: theme.palette.grey[300],
                            p: 0.5,
                            '&:hover': {
                              background: alpha(theme.palette.primary.main, 0.1),
                              color: theme.palette.primary.main,
                            },
                          }}
                          onClick={() => {
                            window.open(social.link);
                          }}
                        >
                          <Iconify icon={social.icon} />
                        </IconButton>
                      ))}
                    </Stack>
                  )}
                  <Typography variant="caption" color={isDarkMode ? 'white' : 'default'}>
                    {t(item.bio)}
                  </Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        )}
      </Stack>
    </Container>
  );
}

export default HomeTeam;
